import { z } from "zod";
import { EncryptedOp, MAX_PUSH_BYTES, StoredOp } from "./ops.js";
import { OpId } from "./primitives.js";

/** WebSocket messages, client → vault Durable Object. */
export const ClientMessage = z.discriminatedUnion("t", [
  z.object({ t: z.literal("hello"), last_seq: z.int().nonnegative() }),
  z.object({ t: z.literal("pull"), from_seq: z.int().nonnegative() }),
  z
    .object({ t: z.literal("push"), ops: z.array(EncryptedOp).min(1).max(200) })
    .refine((v) => v.ops.reduce((n, o) => n + o.ct.length, 0) <= MAX_PUSH_BYTES, "push batch too large"),
  z.object({ t: z.literal("ping") }),
]);
export type ClientMessage = z.infer<typeof ClientMessage>;

export const PushResult = z.object({
  op_id: OpId,
  seq: z.int().positive(),
  /** True when the op was already present (idempotent replay). */
  duplicate: z.boolean(),
});
export type PushResult = z.infer<typeof PushResult>;

/** WebSocket messages, vault Durable Object → client. */
export const ServerMessage = z.discriminatedUnion("t", [
  z.object({
    t: z.literal("ops"),
    ops: z.array(StoredOp),
    /** Highest seq in the log at send time. */
    head: z.int().nonnegative(),
    /** True when more ops remain after this batch; client should `pull` again. */
    more: z.boolean(),
  }),
  z.object({ t: z.literal("ack"), results: z.array(PushResult) }),
  z.object({ t: z.literal("error"), code: z.string(), message: z.string() }),
  z.object({ t: z.literal("pong"), head: z.int().nonnegative() }),
  /** Sent when the device has been revoked; the client must stop and re-enroll. */
  z.object({ t: z.literal("revoked") }),
]);
export type ServerMessage = z.infer<typeof ServerMessage>;
